import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";
import { cn } from "@/lib/utils";
import { useLanguagePreference } from "@/hooks/use-language-preference";

const languages = [
  { value: "en", label: "English" },
  { value: "fr", label: "Français" },
];

export function LanguageSwitcher({ className }: { className?: string }) {
  const { currentLocale, switchLanguage } = useLanguagePreference();
  const current = languages.find((l) => l.value === currentLocale);
  const currentLabel = current?.label ?? currentLocale;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={cn("gap-1.5", className)}
          aria-label={`Language: ${currentLabel}`}
        >
          <Globe className="h-4 w-4" aria-hidden="true" />
          <span className="hidden sm:inline">{currentLabel}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.value}
            onClick={() => switchLanguage(lang.value)}
            aria-current={currentLocale === lang.value ? "true" : undefined}
            className={currentLocale === lang.value ? "text-primary font-medium" : ""}
          >
            {lang.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
